var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "my-5 py-5 px-3 open-salud-prices",
      attrs: { id: "primesalud-price-cards" }
    },
    [
      _c("div", { staticClass: "d-flex flex-column justify-center" }, [
        _c("h3", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.subtitle))]),
        _vm._v(" "),
        _c("p", { staticClass: "main-text" }, [_vm._v(_vm._s(_vm.content))]),
        _vm._v(" "),
        _c("p", { staticClass: "main-text" }, [_vm._v(_vm._s(_vm.subcontent))])
      ]),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass:
            "d-none d-lg-flex justify-content-center desktop-design mt-5"
        },
        _vm._l(_vm.items, function(ref, index) {
          var popular = ref.popular
          var caption = ref.caption
          var title = ref.title
          var price = ref.price
          var services = ref.services
          var subprice = ref.subprice
          var link = ref.link
          var soon = ref.soon
          return _c(
            "v-col",
            {
              key: index,
              class: { popular: popular, standard: !popular },
              attrs: { lg: "3" }
            },
            [
              _c(
                "v-card",
                { staticClass: "card-container" },
                [
                  popular
                    ? _c("div", { staticClass: "text-uppercase py-2" }, [
                        _c("h6", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(popular))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "container-main-text px-4 py-4" }, [
                    caption
                      ? _c("div", { staticClass: "caption text-left mr-5" }, [
                          _c("h4", { staticClass: "mb-3" }, [
                            _vm._v(_vm._s(caption))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h6", { staticClass: "text-left" }, [
                      _vm._v(_vm._s(title))
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mt-4 text-center" }, [
                      _vm._v(_vm._s(price))
                    ]),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(subprice))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticClass: "d-flex justify-content-center" },
                    [
                      _c(
                        "v-list-item-group",
                        { attrs: { "aria-label": title } },
                        _vm._l(services, function(ref, index) {
                          var info = ref.info
                          var type = ref.type
                          return _c(
                            "v-list-item",
                            {
                              key: index,
                              attrs: { "aria-labelledby": _vm.text }
                            },
                            [
                              type === "icon"
                                ? _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", { attrs: { dense: "" } }, [
                                        _vm._v(_vm._s(info))
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              type === "label"
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        domProps: { textContent: _vm._s(info) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              link
                ? _c(
                    "base-button",
                    {
                      staticClass: "ml-4 btn-outline-primary",
                      attrs: { white: "", shadow: "" },
                      on: {
                        click: function($event) {
                          return _vm.$helpers.goToWebApp(link)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.hire_now) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              soon
                ? _c(
                    "base-button",
                    { staticClass: "ml-4", attrs: { white: "", shadow: "" } },
                    [_vm._v("\n        " + _vm._s(_vm.soon_text) + "\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass:
            "responsive-design mt-5 flex-column justify-center d-lg-none d-xs-flex"
        },
        [
          _c("h4", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.$t("price-cards.table.title")))
          ]),
          _vm._v(" "),
          _c("h6", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.$t("price-cards.table.subtitle")))
          ]),
          _vm._v(" "),
          _vm._l(_vm.items2, function(ref, index) {
            var popular = ref.popular
            var caption = ref.caption
            var title = ref.title
            var price = ref.price
            var services = ref.services
            var subprice = ref.subprice
            var link = ref.link
            var soon = ref.soon
            return _c(
              "v-col",
              {
                key: index,
                class: { popular: popular, standard: !popular },
                attrs: { xs: "12" }
              },
              [
                _c(
                  "v-card",
                  { staticClass: "card-container" },
                  [
                    popular
                      ? _c("div", { staticClass: "text-uppercase py-2" }, [
                          _c("h6", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(popular))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "container-main-text px-4 py-4" },
                      [
                        caption
                          ? _c(
                              "div",
                              { staticClass: "caption text-left mr-5" },
                              [
                                _c("h4", { staticClass: "mb-3" }, [
                                  _vm._v(_vm._s(caption))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h6", [_vm._v(_vm._s(title))]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "mt-4" }, [
                          _vm._v(_vm._s(price))
                        ]),
                        _vm._v(" "),
                        _c("small", [_vm._v(_vm._s(subprice))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "v-list-item-group",
                          { attrs: { "aria-label": title } },
                          _vm._l(services, function(ref, index) {
                            var info = ref.info
                            var type = ref.type
                            return _c(
                              "v-list-item",
                              {
                                key: index,
                                attrs: { "aria-labelledby": _vm.text }
                              },
                              [
                                type === "icon"
                                  ? _c(
                                      "v-list-item-icon",
                                      [
                                        _c("v-icon", { attrs: { dense: "" } }, [
                                          _vm._v(_vm._s(info))
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                type === "label"
                                  ? _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          domProps: {
                                            textContent: _vm._s(info)
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                link
                  ? _c(
                      "base-button",
                      {
                        staticClass: "ml-4 btn-outline-primary",
                        attrs: { white: "", shadow: "" },
                        on: {
                          click: function($event) {
                            return _vm.$helpers.goToWebApp(link)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(_vm.hire_now) + "\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                soon
                  ? _c(
                      "base-button",
                      { staticClass: "ml-4", attrs: { white: "", shadow: "" } },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.soon_text) + "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("p", { staticClass: "mb-1" }, [
              _vm._v("* " + _vm._s(_vm.$t("price-cards.permanency")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "m-0" }, [
              _vm._v("** " + _vm._s(_vm.$t("price-cards.family")))
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6da70d2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da70d2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PrimesaludPriceCards.vue
// module id = 3146
// module chunks = 35 36